import { cn, Link } from "@growtherapy/sprout-ui";
import { AddAppointmentButton } from "./AddAppointmentButton";
import { useTrackEvent } from "../../../segment/segment";
import { EventTypeEnum } from "../../../segment/types";

export const AddAppointmentButtonAndReferLink = ({
  onClickAddAppointment,
  isClientUserAccountPaused,
  referClientLink,
  className,
}: {
  onClickAddAppointment: () => void;
  isClientUserAccountPaused: boolean;
  referClientLink: string;
  className?: string;
}): JSX.Element => {
  const { userClicked } = useTrackEvent();

  return (
    <div className={cn("flex gap-4 items-center", className)}>
      <AddAppointmentButton
        onClickHandler={onClickAddAppointment}
        isClientUserAccountPaused={isClientUserAccountPaused}
        buttonClassName="flex items-center gap-3"
      />
      <Link
        onClick={() =>
          userClicked(EventTypeEnum.LINK_CLICKED, {
            cta: "Refer client",
          })
        }
        href={referClientLink}
        buttonUse="secondary"
        className="flex items-center gap-3"
        external
      >
        Refer client
      </Link>
    </div>
  );
};
